<template>
	<article class="d-local-area-page-custom relative">
		<HeroItem
			:data="heroMedia"
			:byline="`${localAreaTitle}`"
			:title="name"
			:autoplay="heroAutoplay"
		/>
		<ContactButton :content="contactpersons" />
		<Facts :data="areaFacts" />
		<div
			v-if="areaDescription"
			class="rte mt-40 text-18 >=768:mt-60 >=768:text-24 >=768:w-3/4"
			v-html="areaDescription"
		></div>
		<BlockList :block-list="contentElements" />
	</article>
</template>

<script>
import HeroItem from '~/components/main/HeroItem';
import BlockList from '~/components/main/BlockList';
import Facts from '~/components/main/Facts';
import ContactButton from '~/components/main/ContactButton';

export default {
	name: 'MainLocalAreaPageCustom',

	components: {
		HeroItem,
		BlockList,
		Facts,
		ContactButton,
	},

	computed: {
		localAreaTitle() {
		  if (this.$store.state.site.id === 1231) {
			return 'Lokalområdet';
		  } else {
			return 'The local area';
		  }
		},
	},

	inheritAttrs: false,

	props: {
		name: String,
		heroMedia: Object,
		heroAutoplay: Boolean,
		contentElements: Array,
		areaFacts: Array,
		areaDescription: String,
		contactpersons: Array,
	},
};
</script>
